import { useQuery } from '@tanstack/react-query'
import { fetchLinkPage } from './api'

/**
 * One page of what a record at `place` may link. See `fetchLinkPage`.
 *
 * Keyed by place, search and page. `placeholderData` keeps the rows on screen
 * while the next page or a new search lands.
 */
export const useLinkPage = (kind, place, params, { enabled = true } = {}) =>
  useQuery({
    queryKey: ['links', kind, place ?? {}, params],
    queryFn: ({ signal }) => fetchLinkPage(kind, place, params, signal),
    placeholderData: (previous) => previous,
    enabled: enabled && Boolean(place),
    staleTime: 30_000,
  })
